import * as React from 'react';

import { getTranslation, keys } from '../../../../../Resources/Translations';
import { Modal, ModalHeading } from '../../../../ReactComponents/Modal/Modal';
import { ProductAvailabilityNotificationSuccess } from './ProductAvailabilityNotificationSuccess';

interface ProductAvailabilityNotificationSuccessModalProps {
    isVisible: boolean;
    onClose: () => void;
}

export const ProductAvailabilityNotificationSuccessModal = (props: ProductAvailabilityNotificationSuccessModalProps) => {
    return (
        <Modal open={props.isVisible} onClose={props.onClose} id="ProductAvailabilityNotificationSuccessModal">
            <ModalHeading>{getTranslation(keys['product.availabilityNotification.modalHeading'])}</ModalHeading>

            <ProductAvailabilityNotificationSuccess />
        </Modal>
    );
};
